// import $ from 'jquery';
//Import Swiper assets
import Swiper from "swiper/bundle";

import "../styles/style.scss";

let swiperInstances = [];

function initSwiper() {
  const swiperContainers = document.querySelectorAll('.wp-block-acf-grid-swiper .swiper');
  swiperContainers.forEach((container) => {
    if (!container.swiper) {
      const swiper = new Swiper(container, {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        lazy: {
          loadPrevNext: true,
        },
      });
      swiperInstances.push(swiper);
    }
  });
}

function destroySwiper() {
  swiperInstances.forEach(swiper => {
    if (swiper && swiper.destroy) swiper.destroy(true, true);
  });
  swiperInstances = [];
}

function handleSwiper() {
  if (window.innerWidth < 776) {
    initSwiper();
    document.body.classList.add('swiper-enabled');
  } else {
    destroySwiper();
    document.body.classList.remove('swiper-enabled');
  }
}

function moveTitleSlide() {
  const swiper = document.querySelector('.wp-block-acf-grid-swiper .swiper');
  const wrapper = swiper ? swiper.querySelector('.swiper-wrapper') : null;
  const titleSlide = wrapper ? wrapper.querySelector('.swiper-slide-title') : null;
  if (!swiper || !wrapper || !titleSlide) return;

  if (window.innerWidth < 776) {
    // Move title slide above swiper if not already moved
    if (!swiper.previousElementSibling || swiper.previousElementSibling !== titleSlide) {
      swiper.parentNode.insertBefore(titleSlide, swiper);
    }
  } else {
    // Move title slide back into swiper-wrapper as first child if not already there
    if (wrapper.firstElementChild !== titleSlide) {
      wrapper.insertBefore(titleSlide, wrapper.firstChild);
    }
  }
}

function moveTitleSlideAll() {
  document.querySelectorAll('.wp-block-acf-grid-swiper').forEach(block => {
    const swiper = block.querySelector('.swiper');
    const wrapper = swiper ? swiper.querySelector('.swiper-wrapper') : null;
    const titleSlide = wrapper ? block.querySelector('.swiper-slide-title') : null;
    if (!swiper || !wrapper || !titleSlide) return;

    if (window.innerWidth < 776) {
      // Destroy Swiper before moving title out
      if (swiper.swiper) {
        swiper.swiper.destroy(true, true);
      }
      // Move title slide above swiper if not already moved
      if (!swiper.previousElementSibling || swiper.previousElementSibling !== titleSlide) {
        swiper.parentNode.insertBefore(titleSlide, swiper);
      }
    } else {
      // Move title slide back into swiper-wrapper as first child before initializing Swiper
      if (wrapper.firstElementChild !== titleSlide) {
        wrapper.insertBefore(titleSlide, wrapper.firstChild);
      }
    }
  });
}

function handleSwiperAll() {
  document.querySelectorAll('.wp-block-acf-grid-swiper .swiper').forEach(container => {
    if (window.innerWidth < 776) {
      // Swiper is destroyed in moveTitleSlideAll
      document.body.classList.add('swiper-enabled');
    } else {
      if (!container.swiper) {
        const swiper = new Swiper(container, {
          direction: 'horizontal',
          loop: true,
          slidesPerView: 1,
          spaceBetween: 30,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          lazy: {
            loadPrevNext: true,
          },
        });
        swiperInstances.push(swiper);
      }
      document.body.classList.remove('swiper-enabled');
    }
  });
}

function updateGridSwiperBlocks() {
  document.querySelectorAll('.wp-block-acf-grid-swiper').forEach(block => {
    const swiper = block.querySelector('.swiper');
    const wrapper = swiper ? swiper.querySelector('.swiper-wrapper') : null;
    const titleSlide = wrapper ? block.querySelector('.swiper-slide-title') : null;
    if (!swiper || !wrapper || !titleSlide) return;

    // Always destroy Swiper if it exists
    if (swiper.swiper) {
      swiper.swiper.destroy(true, true);
    }

    if (window.innerWidth < 1200) {
      // Move title slide above swiper if not already moved
      if (!swiper.previousElementSibling || swiper.previousElementSibling !== titleSlide) {
        swiper.parentNode.insertBefore(titleSlide, swiper);
      }
      // Initialize Swiper for mobile
      if (!swiper.swiper) {
        const instance = new Swiper(swiper, {
          direction: 'horizontal',
          loop: true,
          slidesPerView: 1,
          spaceBetween: 30,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          lazy: {
            loadPrevNext: true,
          },
        });
        swiperInstances.push(instance);
      }
      document.body.classList.add('swiper-enabled');
    } else {
      // Move title slide back into swiper-wrapper as first child before desktop grid
      if (wrapper.firstElementChild !== titleSlide) {
        wrapper.insertBefore(titleSlide, wrapper.firstChild);
      }
      document.body.classList.remove('swiper-enabled');
    }
  });
}

window.addEventListener('DOMContentLoaded', updateGridSwiperBlocks);
window.addEventListener('resize', updateGridSwiperBlocks);

if (typeof window.jQuery !== 'undefined') {
  window.jQuery(window).on('acf/loaded/grid-swiper', () => {
    setTimeout(updateGridSwiperBlocks, 100);
  });
}
